import { render, staticRenderFns } from "./replace-ingredient-update.vue?vue&type=template&id=58a6c24c&"
import script from "./replace-ingredient-update.vue?vue&type=script&lang=js&"
export * from "./replace-ingredient-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports